import React, { createContext, useState, useEffect, useCallback } from "react";
import axios from "axios";

export const FapHouseContext = createContext();

const FAPHOUSE_API = "https://fh-wgt.com/api/request/v1/affiliate_1";
const FAPHOUSE_CAMPAIGN = "ai.oFZ";

// Map our category slugs → FapHouse search keywords
export const CATEGORY_KEYWORD_MAP = {
  "latina-cam-girls":      "latina",
  "ebony-cam-girls":       "ebony",
  "asian-cam-girls":       "asian",
  "milf-cam-girls":        "milf",
  "teen-cam-girls":        "teen",
  "big-ass-cam-girls":     "big ass",
  "big-tits-cam-girls":    "big tits",
  "blonde-cam-girls":      "blonde",
  "brunette-cam-girls":    "brunette",
  "redhead-cam-girls":     "redhead",
  "mature-cam-girls":      "mature",
  "amateur-cam-girls":     "amateur",
  "feet-cam-girls":        "feet",
  "bdsm-cam-girls":        "bdsm",
  "anal-cam-girls":        "anal",
  "squirt-cam-girls":      "squirt",
  "natural-tits-cam-girls":"natural tits",
  "petite-cam-girls":      "petite",
  "lesbian-cam-girls":     "lesbian",
};

/**
 * Fetch FapHouse videos for a given keyword or default (trending).
 * Returns an array of normalized video objects.
 */
export const fetchFapHouseVideos = async ({
  keyword = "",
  orientation = "straight",
  language = "en",
  quantity = 12,
} = {}) => {
  const params = {
    language,
    orientation,
    thumbsMode: "big",
    quantity,
    utmCampaign: FAPHOUSE_CAMPAIGN,
  };
  if (keyword) params.q = keyword;

  const response = await axios.get(FAPHOUSE_API, { params });
  const videos = response.data?.videos || [];

  return videos.map((v) => {
    const rawId = `fh_${v.id}`;
    const slug = v.title
      ? v.title.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 55) + '-' + rawId
      : rawId;
    return {
      id: rawId,
      slug,
      title: v.title,
      thumbnailUrl: v.image2xUrl || v.imageUrl,
      previewUrl: v.previewUrl,
      url: v.url,
      duration: v.duration,
      quality: v.quality,        // "hd" | "4k"
      accessType: v.accessType,  // "gold" | "free"
      orientation: v.orientation,
      payload: v.payload,
      source: "faphouse",
    };
  });
};

export const FapHouseProvider = ({ children }) => {
  const [videos, setVideos]   = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError]     = useState(null);

  // Fetch on mount with default trending content
  const loadVideos = useCallback(async (opts = {}) => {
    setLoading(true);
    setError(null);
    try {
      const results = await fetchFapHouseVideos({ quantity: 20, ...opts });
      setVideos(results);
    } catch (err) {
      console.error("FapHouse fetch error:", err);
      setError(err);
      setVideos([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    loadVideos(); // default: trending straight, no keyword
  }, [loadVideos]);

  return (
    <FapHouseContext.Provider value={{ videos, loading, error, loadVideos }}>
      {children}
    </FapHouseContext.Provider>
  );
};
